import React from "react";

const ACTION_STYLES = {
  details: { background: "#B3CFF2", iconColor: "#000" },
  edit: { background: "#B3CFF2", iconColor: "#000" },
  cancel: { background: "#B3CFF2", iconColor: "#000" },
  delete: { background: "#B3CFF2", iconColor: "#000" },
  more: { background: "#B3CFF2", iconColor: "#000" },
  default: { background: "#B3CFF2", iconColor: "#000" },
};

const TableActions = ({ actions = [], selectedRow = false }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
        flexWrap: "nowrap",
        overflow: "hidden",
        whiteSpace: "nowrap",
      }}
    >
      {actions.map((action, index) => {
        const currentStyle =
          ACTION_STYLES[action.key] || ACTION_STYLES.default;

        const isDisabled = Boolean(action.disabled);
        const makeSelectedRed =
          !isDisabled && selectedRow && action.selectRow === true;

        return (
          <button
            key={`${action.key}-${index}`}
            title={action.label}
            onClick={isDisabled ? undefined : action.onClick}
            disabled={isDisabled}
            style={{
              width: "32px",
              height: "32px",
              minWidth: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: isDisabled
                ? "#E5E7EB"
                : makeSelectedRed
                  ? "#8B0000"
                  : currentStyle.background,
              borderRadius: "6px",
              border: "none",
              padding: 0,
              flexShrink: 0,
              cursor: isDisabled ? "not-allowed" : "pointer",
              color: isDisabled
                ? "#9CA3AF"
                : makeSelectedRed
                  ? "#fff"
                  : currentStyle.iconColor,
              opacity: isDisabled ? 0.7 : 1,
            }}
          >
            <i
              className={action.icon}
              style={{
                fontSize: "14px",
                color: "inherit",
              }}
            />
          </button>
        );
      })}
    </div>
  );
};

export default TableActions;